import React from "react";
import { View, Text, ImageBackground, StyleSheet } from "react-native";

import { store } from "../../../store/store";
import { getImagePath, addFontFamilyStyle } from "../../services/CommonUtils";

import { CommonWhiteMedcordsLogo } from "../CommonAayuLogo";

import { IndiaRupee } from "../../constants/AppConstants";

import AppTheme from "../../../AppTheme";
import TextStyle from "../../../TextStyle";
import AppStyles from "../../../AppStyles";

const setPlanBg = {
    '25': '/images/aayuCard/aayu_card_25.svg',
    '12': '/images/aayuCard/aayu_card_12.svg',
    '8': '/images/aayuCard/aayu_card_8.png',
    '5': '/images/aayuCard/aayu_card_5.svg',
}

const setSquarePlanBg = {
    '25': '/images/aayuCard/aayu_card_sqaure_25.svg',
    '12': '/images/aayuCard/aayu_card_sqaure_12.svg',
    '8': '/images/aayuCard/aayu_card_sqaure_8.svg',
    '5': '/images/aayuCard/aayu_card_sqaure_5.svg',
}

function checkPremiumAayuCard(consultation) {
    return consultation == 25
}

function checkLowestValueCard(consultation) {
    return consultation == 5
}

export const CarouselAayuCardDesign = (props) => {

    return <View style={[AppStyles.flexRowCenter]}>

        <View style={{ shadowRadius: 4, shadowOpacity: 0.4, }} >
            <ImageBackground imageStyle={{ borderRadius: 4 }} style={[AppStyles.px18, { alignItems: "center", justifyContent: "center" }]}
                source={{ uri: getImagePath(setPlanBg[props.aayuCardPlan.consultations.toString()]) }}>
                {checkPremiumAayuCard(props.aayuCardPlan.consultations) ?
                    <View style={styles.popularText}>
                        <Text style={[TextStyle.text8, { textAlign: 'center', color: AppTheme.color.aayuCardColors.premiumText, paddingVertical: 3, paddingHorizontal: 5 }]}>MOST POPULAR</Text>
                    </View> : <View />}
                <Text style={[AppStyles.f16, { paddingVertical: 8, color: AppTheme.color.white }]}>
                    {props.aayuCardPlan.consultations} Consults</Text>
                <Text style={[AppStyles.f12, { marginTop: 4, textDecorationLine: "line-through", color: AppTheme.color.lightGreyColor }]}>
                    {IndiaRupee} {props.aayuCardPlan.originalPrice}</Text>
                <Text style={[TextStyle.text18b, {
                    marginVertical: 6, color: AppTheme.color.white
                }]}>{IndiaRupee} {props.aayuCardPlan.discountedPrice}</Text>
                <Text style={[AppStyles.f12, { marginBottom: 12, color: AppTheme.color.aayuCardColors.priceText }]}>
                    Savings {IndiaRupee} {props.aayuCardPlan.originalPrice - props.aayuCardPlan.discountedPrice}</Text>
                <Text style={[AppStyles.f12, { marginVertical: 10, color: AppTheme.color.white }]}>
                    Valid for 12 months</Text>
            </ImageBackground>
            <View style={{ position: "absolute", top: 4, left: 4 }}><CommonWhiteMedcordsLogo /></View>
        </View>
        {checkLowestValueCard(props.aayuCardPlan.consultations) ? <View style={{ width: 16 }} /> : <View />}
    </View>
}

export const AayuCardDesign = (props) => {

    const reduxState = store.getState()
    const userName = reduxState.userDetails['isProfileComplete'] ? reduxState.userDetails['name'] : null
    const consultations = props.aayuCardPlan.consultations ?? 25;
    const borderRadius = props.radius ?? 4
    const margin = props.margin ?? 32

    return <View style={{ alignSelf: "center", borderRadius: borderRadius, width: AppTheme.appWidth - (margin * 2) }}>
        <ImageBackground resizeMode='cover' imageStyle={{ borderRadius: borderRadius }}
            source={{ uri: getImagePath(setPlanBg[consultations.toString()]) }}>
            <View style={{ alignContent: "space-between" }}>
                <View style={{ height: 30, marginRight: 16, justifyContent: "flex-start", alignItems: "flex-end" }}>
                    {
                        checkPremiumAayuCard(consultations) ? <View style={{
                            width: 120, justifyContent: "center",
                            backgroundColor: AppTheme.color.aayuCardColors.premiumPrimary
                        }}>
                            <Text style={[TextStyle.text12b, { marginVertical: 4, color: AppTheme.color.aayuCardColors.premiumText, textAlign: 'center' }]}>
                                MOST POPULAR</Text></View> : <View />
                    }
                </View>
                <View style={{ flexDirection: "row", margin: 16, justifyContent: "space-between", alignContent: "flex-start" }}>

                    <View style={{ alignItems: "flex-start", width: (AppTheme.appWidth - margin * 2 - 32) * 0.6 }}>
                        <Text style={{ fontSize: 24, fontWeight: '600', color: AppTheme.color.aayuCardColors.planText }}>
                            {consultations} Consults</Text>
                        <Text style={{
                            fontSize: 14, fontWeight: '400', marginTop: 12, marginBottom: 16,
                            color: AppTheme.color.white
                        }}>Validity: <Text style={{ fontWeight: "500" }}>12 months</Text></Text>
                        {!!userName && <Text style={{ fontSize: 16, fontWeight: '400', color: AppTheme.color.aayuCardColors.planText }}>
                            {userName.toUpperCase()}'s family</Text>}
                    </View>

                    <View style={{ alignItems: "flex-end", width: (AppTheme.appWidth - margin * 2 - 32) * 0.4 }}>
                        <Text style={{ fontSize: 24, fontWeight: '600', color: AppTheme.color.aayuCardColors.priceText }}>
                            {IndiaRupee} {props.aayuCardPlan.discountedPrice}
                        </Text>
                        <Text style={{
                            fontSize: 16, fontWeight: '400', marginTop: 8, marginBottom: 4,
                            textDecorationLine: "line-through", color: AppTheme.color.white
                        }}>
                            {IndiaRupee} {props.aayuCardPlan.originalPrice}
                        </Text>
                        <Text style={{ fontSize: 14, fontWeight: '400', marginTop: 8, color: AppTheme.color.aayuCardColors.savingText }}>
                            Savings {IndiaRupee} {props.aayuCardPlan.originalPrice - props.aayuCardPlan.discountedPrice}
                        </Text>
                    </View>

                </View>
            </View>
        </ImageBackground>
    </View>
}

export const SubscriptionAayuCardDesign = (props) => {
    return <ImageBackground source={{ uri: getImagePath(setPlanBg[props.subscriptionData.maxConsultations]) }}
        style={{ borderRadius: 15, marginTop: 8 }} imageStyle={{ borderRadius: 12 }}>
        <View style={{ height: 30 }} />
        <View style={{ borderRadius: 8, marginVertical: 8, marginHorizontal: 16 }}>
            {props.subscriptionData.userName !== '' && <View>
                <Text style={[styles.familyLabel, { marginBottom: 8, color: AppTheme.color.aayuCardColors.planText }]}>{props.subscriptionData.userName}</Text>
                <Text style={[styles.familyCovered, { color: AppTheme.color.white }]}>Whole Family Covered</Text>
                <Text style={[styles.validDate, { color: AppTheme.color.white }]}>Valid From </Text>
                <Text style={[styles.dateValid, { marginBottom: 8, color: AppTheme.color.white }]}>
                    {props.subscriptionData.validFromDate}</Text>
                <Text style={[styles.validDate, { color: AppTheme.color.white }]}>
                    Valid Till </Text>
                <Text style={[styles.dateValid, { color: AppTheme.color.white }]}>
                    {props.subscriptionData.validTillDate}</Text>
            </View>}
        </View>
    </ImageBackground>
}

export class AayuCardDesignView extends React.Component<any, any> {

    render() {
        const width = AppTheme.appWidth;
        const plan = this.props.aayuCardPlan;
        return <View style={[{ borderRadius: 4, alignContent: 'center', width: 140 }]}>
            <ImageBackground imageStyle={{ borderRadius: 4 }}
                source={{ uri: getImagePath(setPlanBg[plan.consultations.toString()]) }}>
                <Text style={[styles.consultText,
                { color: AppTheme.color.white }]}>
                    {plan.consultations} Consults</Text>
                <Text style={[{ textDecorationLine: "line-through", color: AppTheme.color.lightGreyColor }]}>
                    {IndiaRupee} {plan.originalPrice}
                </Text>
                <Text style={[styles.priceText,
                { color: AppTheme.color.white }]}>
                    {IndiaRupee} {plan.discountedPrice}
                </Text>
                <Text style={{ color: AppTheme.color.aayuCardColors.planText }}>
                    Saves {IndiaRupee} {plan.originalPrice - plan.discountedPrice}
                </Text>
                <Text></Text>
                <View></View>
            </ImageBackground>
            {
                checkPremiumAayuCard(plan.consultations) ? <View style={{
                    position: "absolute", right: 0,
                    borderRadius: 4, backgroundColor: AppTheme.color.aayuCardColors.premiumPrimary
                }}>
                    <Text style={{ fontSize: 12 }}>
                        M{'\n'}O{'\n'}S{'\n'}T{'\n'}{'\n'}P{'\n'}O{'\n'}P{'\n'}U{'\n'}L{'\n'}A{'\n'}R</Text>
                </View> : <View />
            }
        </View>
    }
}

const styles = StyleSheet.create(addFontFamilyStyle({
    popularText: {
        transform: [{ rotate: '90deg' }], borderRadius: 4, position: "absolute",
        top: 53, right: -27, backgroundColor: AppTheme.color.aayuCardColors.premiumPrimary,
    },
    activatePlan: {
        fontSize: 14,
        lineHeight: 19,
        color: '#fff',
        textAlign: "center",
        fontWeight: '600'
    },
    consultText: {
        fontSize: 24,
        fontWeight: '600',
        marginTop: 8
    },
    validText: {
        fontSize: 14,
    },
    familyText: {
        marginVertical: 20
    },
    priceText: {
        fontSize: 24,
        marginTop: 8
    },
    originalPrice: {
        textDecorationLine: "line-through",
        fontSize: 20
    },
    familyLabel: {
        fontSize: 18, lineHeight: 24, textAlign: "left"
    },
    familyCovered: {
        fontSize: 14, lineHeight: 10, textAlign: "left", letterSpacing: 1.5, fontWeight: '400'
    },
    validDate: {
        fontSize: 12, textAlign: "right", lineHeight: 10, fontWeight: '400', marginBottom: 6,
    },
    dateValid: {
        fontSize: 14, lineHeight: 16, textAlign: "right", paddingBottom: 5, fontWeight: '600'
    },
    activateBtn: {
        width: '90%',
        position: "relative",
        top: -25,
        padding: 8,
        borderRadius: 8,
        left: 10

    }
}))